type ApiOk<T> = { ok: true } & T;
type ApiErr = { ok: false; error: string };

const API_BASE = "/api/index.php";

async function apiFetch<T>(path: string, options: RequestInit = {}): Promise<ApiOk<T>> {
  const res = await fetch(API_BASE + path, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...(options.headers || {})
    },
    credentials: "include"
  });

  const data = (await res.json()) as ApiOk<T> | ApiErr;
  if (!data.ok) throw new Error(data.error || "Erreur API");
  return data as ApiOk<T>;
}

export const Api = {
  me: () => apiFetch<{ user: any | null }>("/auth/me"),
  register: (email: string, password: string) =>
    apiFetch<{ user: any }>("/auth/register", { method: "POST", body: JSON.stringify({ email, password }) }),
  login: (email: string, password: string) =>
    apiFetch<{ user: any }>("/auth/login", { method: "POST", body: JSON.stringify({ email, password }) }),
  logout: () => apiFetch<{}>("/auth/logout", { method: "POST", body: JSON.stringify({}) }),

  getBest: (gameId: string) =>
    apiFetch<{ best: number }>(`/scores/best?game_id=${encodeURIComponent(gameId)}`),

  submitScore: (gameId: string, score: number) =>
    apiFetch<{ best: number }>("/scores/submit", {
      method: "POST",
      body: JSON.stringify({ game_id: gameId, score })
    }),

  leaderboard: (gameId: string, limit = 20) =>
    apiFetch<{ items: Array<{ email: string; score: number; updated_at: string }> }>(
      `/scores/leaderboard?game_id=${encodeURIComponent(gameId)}&limit=${limit}`
    )
};
